import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DisplayTextService {
  /**
   * Genera un texto amigable para mostrar en autocompletes u otras vistas.
   * @param option Objeto a interpretar.
   * @returns Texto legible según la estructura del objeto.
   */
  getTextGenerico(option: any): string {
    if (!option) return '';

    if (option.codigo && option.nombre && option.apellido) {
      return `${option.nombre} ${option.apellido}`;
    }
    
    if (option.idempleado && option.nombre && option.apellido) {
      return `${option.nombre} ${option.apellido}`;
    }

    if (option.codigo && option.fecha) {
      return `N° ${option.numero} | ${option.proveedor_descripcion} ${option.fecha}`;
    }

    if (option.razonSocial) {
      return option.razonSocial;
    }

    if (option.RazonSocial) {
      return option.RazonSocial;
    }

    if (option.razon_social) {
      return option.razon_social;
    }

    if (option.idcomprasperiodo) {
      return `${option.mes}/${option.anio}`;
    }

    if (option.idarticulo && option.codigo_interno && option.descripcion) {
      return option?.idarticulo ? `${option.codigo_interno} - ${option.descripcion}` : '';
    }

    if (option.deposito) {
      return option.deposito;
    }

    if (option.descripcion) {
      return option.descripcion;
    }

    if (option.deposito_descripcion) {
      return option.deposito_descripcion;
    }

    if (option.correo_electronico) {
      return option.correo_electronico;
    }

    if (option.codigo) {
      if (option.nombre && option.apellido) {
        return `${option.nombre} ${option.apellido}`;
      }
      if (option.nombre) {
        return `${option.nombre}`;
      }
      if (option.razonSocial) {
        return option.razonSocial;
      }
      if (option.razon_social) {
        return option.razon_social;
      }
      if (option.descripcion) {
        return option.descripcion;
      }
      return '';
    }

    if (option.usuario) {
      return option.usuario;
    }

    if (option.idunidadfuncional) {
      return option.descripcion_complejo_uf;
    }

    if (option.idcomplejo) {
      return option.descripcion_complejo;
    }

    if (option.numero_venta || option.idventa || option.idventagenerica) {
      if (option.descripcion_venta) {
        return option.descripcion_venta;
      } else {
        const num = option.numero_venta || option.idventa || option.idventagenerica;
        const clienteStr = option.cliente ? option.cliente : 'Sin Cliente';
        const fechaStr = option.fecha || (option.fecha_hora ? (typeof option.fecha_hora === 'string' ? option.fecha_hora.split(' ')[0] : option.fecha_hora) : '');
        return `N° ${num} | ${clienteStr}${fechaStr ? ' ~ ' + fechaStr : ''}`;
      }
    }

    if (option.numero_venta === null || (option.idventa === null && option.idventagenerica === null)) {
      return `Sin Asignación`;
    }

    if (option.dominio){
      return option.dominio;
    }

    if (option.nombre) {
      return option.nombre;
    }

    return '';
  }

  /**
   * Normaliza un texto convirtiendo a minúsculas, recortando espacios y
   * eliminando tildes/acentos diacríticos (ej. "Jerónimo" -> "jeronimo").
   */
  normalizarTexto(texto: any): string {
    if (!texto && texto !== 0) return '';
    return texto
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  /**
   * Determina si todos los términos o palabras de una búsqueda existen dentro del texto objetivo,
   * sin importar el orden en que se escribieron ni la presencia de tildes/acentos.
   *
   * Ejemplo: query "huinca jeronimo" coincide con objetivo "Jerónimo Huinca"
   */
  coincideBusqueda(textoObjetivo: any, query: any): boolean {
    const normQuery = this.normalizarTexto(query);
    if (!normQuery) return true;

    const normTarget = this.normalizarTexto(textoObjetivo);
    if (!normTarget) return false;

    const tokens = normQuery.split(/\s+/).filter(Boolean);
    return tokens.every(token => normTarget.includes(token));
  }
}
